module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-57.eeda501.woff2";